import { createContext, useContext, useState } from "react";

export const UIContext = createContext();

export const useUIContext = () => useContext(UIContext);

export const UIProvider = ({ children }) => {
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const cartPopUpFunction = () => {
    setPopupVisible(true);
    // Auto-hide popup after 3 seconds
    setTimeout(() => setPopupVisible(false), 3000);
  };

  const value = {
    isPopupVisible,
    cartPopUpFunction,
    isLoading,
    setIsLoading,
  };

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
};
